module.exports = __webpack_public_path__ + "static/media/munch13.11133191.wav";